/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Vue, Component } from 'vue-property-decorator';
import BaseForm from './components/base-form';

const style = require('./index.module.scss');

@Component({ name: 'AdditionalInfo' })
export default class AdditionalInfo extends Vue {
  private render() {
    return (
      <div class={style['additional-info']}>
        <div class={style.safeTips}>
          <span class={style.safeIcon}></span>
            哈啰承诺信息安全加密，
          <span class={style.strong}>
            严格保障你的信息安全
          </span>
        </div>
        <BaseForm />
      </div>
    );
  }
}
